import { render } from "./CoderSection.vue?vue&type=template&id=ecab9992&scoped=true"
import script from "./CoderSection.vue?vue&type=script&lang=js"
export * from "./CoderSection.vue?vue&type=script&lang=js"

import "./CoderSection.vue?vue&type=style&index=0&id=ecab9992&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecab9992"]])

export default __exports__